module.exports = __webpack_public_path__ + "static/media/ic-more-combine.bae5328b.png";